module.exports = __webpack_public_path__ + "img/noData.8557345a.png";